import { useMutation, useQuery } from '@tanstack/react-query';
import {
  getHrWorkEnvironmentOverview,
  remindAboutPlan,
  remindToSurvey,
} from '../../../api/hrWorkEnvironment';

export const HrWorkEnvironmentOverviewQueryKey = 'HR_WORK_ENVIRONMENT_OVERVIEW';

export const useHrWorkEnvironmentOverviewQuery = (
  language: string,
  enabled = true,
) =>
  useQuery({
    queryKey: [HrWorkEnvironmentOverviewQueryKey, language],
    queryFn: () => getHrWorkEnvironmentOverview(language),
    enabled,
  });

export const useRemindAboutPlanMutation = () =>
  useMutation({ mutationFn: (surveyId: number) => remindAboutPlan(surveyId) });

export const useRemindToSurveyMutation = () =>
  useMutation({ mutationFn: (teamIds: number[]) => remindToSurvey(teamIds) });
